// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TargetTypes } from "./Shared.TargetTypes.gen";
import { OperationMode } from "./Shared.OperationMode.gen";
import { ChirpOperationMode } from "./Shared.ChirpOperationMode.gen";

export interface IChirpConfig {
	id: string | undefined;

	dateCreated: string | undefined;

	name: string | undefined;

	description: string | undefined;

	minFirmwareVersion: string | undefined;

	minDistanceM: number | undefined;

	maxDistanceM: number | undefined;

	biDirectional: boolean | undefined;

	minBoresightSpeedM: number | undefined;

	maxBoresightSpeedM: number | undefined;

	angleToTrafficDeg: number | undefined;

	targetType: TargetTypes | undefined | number ;

	deviceMode: OperationMode | undefined;

	deviceModes: ChirpOperationMode | undefined | number ;

	chirpConfig: string | undefined;

	radarTrackerConfigId: string | undefined;

	videoTrackerConfigId: string | undefined;

	isDeleted: boolean;

	$type?: string | undefined;
}
export class ChirpConfig {
	constructor(data?: IChirpConfig) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
	}

	id: string | undefined;

	dateCreated: Date | undefined = new Date();

	name: string | undefined;

	description: string | undefined;

	minFirmwareVersion: string | undefined;

	minDistanceM: number | undefined;

	maxDistanceM: number | undefined;

	biDirectional: boolean | undefined;

	minBoresightSpeedM: number | undefined;

	maxBoresightSpeedM: number | undefined;

	angleToTrafficDeg: number | undefined;

	targetType: TargetTypes | undefined | number ;

	deviceMode: OperationMode | undefined;

	deviceModes: ChirpOperationMode | undefined | number ;

	chirpConfig: string | undefined;

	radarTrackerConfigId: string | undefined;

	videoTrackerConfigId: string | undefined;

	isDeleted: boolean = false;

	static $type: string = "CoreApi.Models.ChirpConfig, ";
	$type?: string | undefined = ChirpConfig.$type;
}

